<script lang="ts">
	import { page } from '$app/state';

	import * as Breadcrumb from '$lib/components/ui/breadcrumb';

	const crumbs = $derived(page.data.breadcrumbs.slice(0, page.data.breadcrumbs.length - 1));
	const current = $derived(page.data.breadcrumbs.at(-1));
</script>

<Breadcrumb.Root class="flex-1">
	<Breadcrumb.List>
		{#each crumbs as crumb (crumb)}
			<Breadcrumb.Item class="hidden md:block">
				<Breadcrumb.Link href={crumb.href} class="text-balance">{crumb.title}</Breadcrumb.Link>
			</Breadcrumb.Item>

			<Breadcrumb.Separator class="hidden md:block text-muted-foreground/20" />
		{/each}

		{#if current}
			<Breadcrumb.Item>
				<Breadcrumb.Page class="text-balance">{current.title}</Breadcrumb.Page>
			</Breadcrumb.Item>
		{/if}
	</Breadcrumb.List>
</Breadcrumb.Root>
